import ExcelExampleTable, {
  ExcelExampleTableRow,
} from "ui/components/ExcelExampleTable";

function TabelaExemplo() {
  return <ExcelExampleTable rows={rows} />;
}

const rows: ExcelExampleTableRow[] = [
  {
    cabecalho: "mes",
    tipo: "texto",
    obrigatorio: "Sim",
    observacao:
      "Deve ser o número do mês em 1 ou 2 dígitos. Ex: 1 para Janeiro, 2 para Fevereiro, 12 para Dezembro, etc.",
  },
  {
    cabecalho: "categoria",
    tipo: "texto",
    obrigatorio: "Sim",
    observacao: "Nome ou código da categoria. Ex: 1.1, Juros, Taxa Condominial",
  },
  {
    cabecalho: "valor",
    tipo: "decimal",
    obrigatorio: "Sim",
    observacao: 'Casas decimais separadas por "."',
  },
];

export default TabelaExemplo;
